
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/menu/[restaurantSlug]",
      function () {
        return require("private-next-pages/menu/[restaurantSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/menu/[restaurantSlug]"])
      });
    }
  